import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import FilterController from './FilterController.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterView',
  props: {
    value: {},
    allProps: {},
    availableProps: {},
    permanent: {},
    parameters: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function handleFilter(parameters: any) {
  emit('input', parameters)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FilterController, _mergeProps({
    receive: _ctx.allProps.receive,
    all: _ctx.allProps.result && _ctx.allProps.result.items,
    permanent: _ctx.permanent,
    parameters: _ctx.parameters
  }, _ctx.$attrs, {
    loading: _ctx.allProps.loading || false,
    value: _ctx.value,
    onInput: handleFilter
  }), {
    append: _withCtx((scope) => [
      _renderSlot(_ctx.$slots, "append", _normalizeProps(_guardReactiveProps(scope)))
    ]),
    _: 3
  }, 16, ["receive", "all", "permanent", "parameters", "loading", "value"]))
}
}

})